import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { MsalBroadcastService } from '@azure/msal-angular';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  errorMessage: string;
  showDetails: boolean;
  isAuthenticating = false;

  constructor(
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {
    const navigation = this.router.getCurrentNavigation();

    // Check if the user has no active accounts (token expired / session lost).
    // If so, trigger re-authentication instead of showing the error page.
    const accounts = this.msalService.instance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      this.isAuthenticating = true;
      this.msalService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
      return;
    }

    // Check if navigation exists and has state
    if (navigation?.extras?.state) {
      const state = navigation.extras.state as { message?: string; showDetails?: boolean };
      this.errorMessage = state.message || 'An error occurred, but no additional details are available.';
      this.showDetails = state.showDetails || false;
    } else {
      // No navigation state available (e.g., page refresh or direct navigation)
      this.errorMessage = 'An error occurred, but no additional details are available.';
      this.showDetails = false;

      this.router.navigate(['/']);
    }
  }
}
